import styled from 'styled-components';
import Multiselect from 'react-widgets/lib/Multiselect';
import { CommonDiv } from 'styles/common';
import 'react-dropdown/style.css';

export const MultiSelect = styled(Multiselect)`
  margin-top: 4px;
  .rw-widget {
    margin-top: 4px;
  }

  .rw-widget > .rw-widget-container {
    margin-top: 4px;
  }
  .rw-widget-container {
    border: solid 1px
      ${props =>
    props.active
      ? props.theme.color.primary
      : props.error
        ? props.theme.color.error
        : props.theme.color.border};
  }
  .rw-list-option {
    padding: 0.688em 0.688em;
    font-family: 'HelveticaNeue', 'Helvetica Neue';
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${(p) => p.theme.color.text};
  }

  .rw-list-option.rw-state-selected,
  .rw-list-option.rw-state-selected:hover {
    background-color: #f5f5f9;
    border: 0;
    color: ${(p) => p.theme.color.text};
  }

  .rw-list-option.rw-state-focus,
  .rw-list-option.rw-state-focus:hover {
    background-color: #f5f5f9;
    border: 0;
    color: ${(p) => p.theme.color.text};
  }

  .rw-dropdown-list-input {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 11px 0px 11px 10px;
    text-align: left;
    background-color: #ffffff;
    font-family: 'HelveticaNeue', 'Helvetica Neue';
    font-size: 1rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    -webkit-letter-spacing: normal;
    -moz-letter-spacing: normal;
    -ms-letter-spacing: normal;
    letter-spacing: normal;
    color: ${(p) => p.theme.color.text};
  }
  .rw-popup {
    margin-top: 8px;
    border-radius: 4px;
  }

  /* Specific for multiselect */

  span.rw-select:after {
    content: '';
    display: inline-block;
    border: 7px solid transparent;
    border-top: 7px solid ${(p) => p.theme.color.text};
    position: absolute;
    top: 45%;
    left: 10px;
    opacity: 0.7;
    z-index: 1;
  }
  .rw-input-reset {
    caret-color: transparent !important;
  }
`;

export const ErrorMessage = styled(CommonDiv)`
  color: ${props => props.theme.color.error};
  font-size: 12px;
  text-align: right;
  margin-top: 2px;
`;
